import { render, staticRenderFns } from "./directFaqItem.vue?vue&type=template&id=6bc880fc&scoped=true"
import script from "./directFaqItem.vue?vue&type=script&lang=js"
export * from "./directFaqItem.vue?vue&type=script&lang=js"
import style0 from "./directFaqItem.vue?vue&type=style&index=0&id=6bc880fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc880fc",
  null
  
)

export default component.exports